<template>
  <div
    v-if="settings"
    class="d-flex"
    :class="[{ 'justify-center': $vuetify.breakpoint.xsOnly }, logoPosition]"
    :style="settings.logo.align[1] !== 'start' ? 'min-height: 120px;' : ''"
  >
    <v-img
      :max-width="logoSize[0]"
      :max-height="logoSize[1]"
      contain
      :src="settings ? settings.logo_large : '/cdn/welcome_medium.png'"
      :alt="$t('images.misc.community_logo')"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "HeaderLogin",
  computed: {
    ...mapGetters("community", { settings: "get_settings" }),
    logoSize() {
      if (!this.settings) return [200, 160];
      let x = this.$vuetify.breakpoint.xsOnly
        ? this.settings.logo.size_xs[0]
        : this.settings.logo.size[0];
      let y = this.$vuetify.breakpoint.xsOnly
        ? this.settings.logo.size_xs[1]
        : this.settings.logo.size[1];
      return [x, y];
    },
    logoPosition() {
      if (this.settings) {
        let horizontal = this.$vuetify.breakpoint.xsOnly
          ? this.settings.logo.align_xs[0]
          : this.settings.logo.align[0];
        let vertical = this.$vuetify.breakpoint.xsOnly
          ? this.settings.logo.align_xs[1]
          : this.settings.logo.align[1];
        return `align-${vertical} justify-${horizontal}`;
      } else return "align-center justify-center";
    },
  },
};
</script>
